import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./TransferActionForm";
import {cancelDispatchStockTransfer, successDispatchStockTransfer} from "../../../actions/StockTransferApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class DispatchStockTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit() {
    return this.props.dispatchStockTransfer({transferId: this.props.transferId})
      .then((response) => {
        let serverErrors = response.data.dispatchStockTransfer.errors;
        if (serverErrors.length <= 0) {
          this.props.successDispatchStockTransfer();
        } else {
          // A dispatch is rejected per stock sku when the origin cannot cover the
          // transfer ("Insufficient stock: 60 short of ... at origin."), or per
          // serial number when a container can no longer move (decommissioned
          // since it was added, say). The form has no field to hang those on, so
          // show them, one per line, as the form error.
          let message = serverErrors.map((error) => error.message).join("\n");
          let errors = createValidationErrors(serverErrors, message || "An error occured");
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDispatchStockTransfer();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        submitLabel="Dispatch Transfer"
        message="Dispatch this transfer? Stock will be drawn down from the origin warehouse (unless the origin is the factory), so the origin must hold every sku on the manifest."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const DISPATCH_STOCK_TRANSFER = gql`
  mutation dispatchStockTransfer($data: DispatchStockTransferInput!) {
    dispatchStockTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(DISPATCH_STOCK_TRANSFER, {
    props: ({ mutate }) => ({
      dispatchStockTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelDispatchStockTransfer, successDispatchStockTransfer})(withMutation(DispatchStockTransferFormContainer));
